module.exports = __webpack_public_path__ + "01996a4ba3ac30072b704766d5a92d2b.png";